




















import { Component, Mixins, Prop } from "vue-property-decorator";
import { default as VueRecaptcha } from "vue-recaptcha";
import { DomainRegistry } from "../../domain";

@Component({
  components: {
    VueRecaptcha,
  }
})
export default class FolderAuthenticationView extends Mixins() {
  @Prop()
  guid: string;

  data(): any {
    return {
      isAuthenticating: false,
      password: null,
      recaptchaResponse: null,
    };
  }
  isAuthenticating: boolean;
  password: string;
  recaptchaResponse: string;

  $refs!: {
    recaptcha: VueRecaptcha,
  };

  get recaptchaKey(): string {
    return this.$configuration.reCaptcha.siteKey;
  }

  authenticate(): void {
    if (this.isAuthenticating) { return; }
    const service = DomainRegistry.folder.getFolderService();
    service.authenticate(this.guid, this.password, this.recaptchaResponse)
      .then((e) => {
        const errorMessage = this.toErrorMessage(e);
        if (errorMessage === "") {
          this.$success(
            "認証成功",
            "認証しました。",
          );
          (this.$el as HTMLElement).focus(); // IEで入力項目にフォーカスが当たったまま遷移した場合、上記カードが消えるまで押せなくなる問題の対応
          this.handleAuthenticationSucceeded();
        } else {
          this.handleAuthenticationFailed(
            null,
            "認証失敗",
            errorMessage,
          );
        }
      })
      .catch(e => {
        this.handleAuthenticationFailed(
          e,
          "認証失敗",
          "認証失敗しました。",
        );
      }
    );
  }

  private toErrorMessage(errorCode: number): string {
    switch (errorCode) {
      case 1:
        return "該当URLのフォルダは既に削除されています。";
      case 2:
        return "該当URLのフォルダは非公開です。";
      case 3:
        return "URLが違います。";
      case 4:
        return "アクセスコードが違います。";
      default:
        return "";
    }
  }

  get isRecaptchaVerified(): boolean {
    return !!this.recaptchaResponse;
  }

  onRecaptchaVerified(response: string): void {
    this.recaptchaResponse = response;
  }

  onRecaptchaExpired(): void {
    this.recaptchaResponse = null;
  }

  private async handleAuthenticationSucceeded(): Promise<void> {
    const destination = this.queryParameterToFirstString(this.$route.query.redirect);
    this.$router.replace(destination ? destination : "/Error");
  }

  private queryParameterToFirstString(value: string | (string | null)[]): string {
    return Array.isArray(value)
      ? ((0 < value.length) ? value[0] : null)
      : value;
  }

  private handleAuthenticationFailed(error: Error, title: string, message: string): void {
    this.password = "";
    this.$refs.recaptcha.reset();
    this.$error(
      title,
      message,
      error,
    );
  }
}
